/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const CollaborationEvaluation = {

	get (context, contestId, bidderId, onSuccess, onError, options) {
		Api.get(context,
			"/collaboration-evaluation"
			+ "?contestId=" + contestId
			+ "&bidderId=" + bidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/collaboration-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestCollaborators (context, contestId, yearFromId, yearToId, onSuccess, onError, options) {
		Api.get(context,
			"/collaboration-evaluation/contest-collaborators"
			+ "?contestId=" + contestId
			+ "&yearFromId=" + yearFromId
			+ "&yearToId=" + yearToId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCollaboratorEvaluation (context, contestId, bidderId, collaborationEvaluationDTO, onSuccess, onError, options) {
		Api.post(context,
			"/collaboration-evaluation/collaborator-evaluation"
			+ "?contestId=" + contestId
			+ "&bidderId=" + bidderId
			, collaborationEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportCollaborators (context, contestId, yearFromId, yearToId, onSuccess, onError, options) {
		Api.post(context,
			"/collaboration-evaluation/export-collaborators"
			+ "?contestId=" + contestId
			+ "&yearFromId=" + yearFromId
			+ "&yearToId=" + yearToId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
